








































import {Component, Vue} from 'vue-property-decorator'
import {$, ID} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import DevolverNota from '@/model/request/DevolverNota'
import Carga from '@/model/resource/Carga'
const sha1 = require('sha1')

@Component
export default class ModalCargaFinalizadaParaNaoIniciada extends Vue {
  idCarga: ID | null = null
  password: string | null = null

  async openEvent(idCarga: ID) {
    this.$emit('open')
    this.idCarga = idCarga
  }

  closeEvent() {
    this.idCarga = null
    this.password = null
    this.$emit('close')
  }

  close() {
    this.$modal.close('modalCargaFinalizadaParaNaoIniciada')
  }

  async submit() {
    if (!this.idCarga) {
      return
    }

    if (!this.password) {
      Helper.abort('modal.modalCargaFinalizadaParaNaoIniciada.passwordCannotBeEmpty')
    }

    const request = new DevolverNota()
    request.password = sha1(this.password)
    request.idCarga = this.idCarga

    try {
      await Carga.setCargaFinalizadaParaNaoIniciada(request)
      Helper.success('modal.modalConfirmEditCarga.success')
      this.$emit('success')
      this.close()
    } catch {
      // pass
    }
  }

}
